import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function ExpeditorStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Notificarea este trimisa de chirias"
          description="Activeaza daca notificarea este trimisa de chirias catre proprietar"
          checked={!!data.expeditorEsteChirias}
          onChange={() => update("expeditorEsteChirias")(!data.expeditorEsteChirias)}
        />
      </div>

      <InputField label="Nume complet" value={data.expeditorNume} onChange={update("expeditorNume")} placeholder="ex: Popescu Ion" required error={errors.expeditorNume} />
      <InputField label="Adresa de domiciliu" value={data.expeditorAdresa} onChange={update("expeditorAdresa")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.expeditorAdresa} />
      <OptionalFields>
        <InputField label="CNP" value={data.expeditorCNP} onChange={update("expeditorCNP")} placeholder="ex: 1234567890123" half error={errors.expeditorCNP} helperText="Opțional — poți completa de mână pe document" />
        <InputField label="Serie si nr. CI" value={data.expeditorCI} onChange={update("expeditorCI")} placeholder="ex: RD 123456" half error={errors.expeditorCI} helperText="Opțional — poți completa de mână pe document" />
      </OptionalFields>
    </div>
  );
}
